import { Text, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export interface HeaderProps {
  title: string;
}

export const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <HStack space={Spacing['inline.nano']} alignItems={'center'} justifyContent={'space-between'}>
      <Text
        variant="semibold"
        numberOfLines={2}
        fontSize={Typography['fontsize.md']}
        color="neutral.dark">
        {title}
      </Text>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.dark">
        CARTEIRA
      </Text>
    </HStack>
  );
};
